module.exports = __webpack_public_path__ + "static/media/Stephanie Book White Headshot.915b8ac3.jpeg";